import '@zillow/cosmos/dist/styles.css';
import './index.css';

import { renderClientIndex } from '@zg-rentals/rental-manager-env';
import App from './App';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { setClient as setLeasingClient } from '@zg-rentals/ts-leasing-client';
import { setClient as setRinsClient } from '@zg-rentals/ts-rins-client';
import { analytics } from './analytics';

renderClientIndex({
  app: <App />,
  appName: __APP_NAME__,
  ddApplicationId: __DD_APP_ID__,
  ddClientToken: __DD_CLIENT_TOKEN__,
  onBootstrapRegister: analytics.initialize,
});

// Set Panda CSS theme for Constellation v10
document.documentElement.setAttribute('data-panda-theme', 'legacy-zillow');

module.hot?.accept();

setLeasingClient(
  getClient().extend({
    prefixUrl: __DEV__ ? (__API__.includes('localhost') ? __API__ : `${__API__}rental`) : '/rental',
  }),
);

setRinsClient(
  getClient().extend({
    prefixUrl: __DEV__ ? (__API__.includes('localhost') ? __API__ : `${__API__}rental`) : '/rental',
  }),
);
